export default __webpack_public_path__ + "static/media/karada-arrange-product-details.7919aec8.jpg";